import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import { switchMap, map, catchError, tap } from 'rxjs/operators';
import { PredictionService } from '../../services/prediction.service';
import * as PredictionActions from '../actions/prediction.actions';
import { MessageService } from 'primeng/api';

@Injectable({ providedIn: 'root' })
export class PredictionEffects {
    private predictionService = inject(PredictionService);
    private router = inject(Router);
    private actions$ = inject(Actions);
    private messageService = inject(MessageService); 

    loadUserPredictions$ = createEffect(() =>
        this.actions$.pipe(
            ofType(PredictionActions.loadUserPredictions),
            switchMap(({ userId }) =>
                this.predictionService.getPredictionById(userId).pipe(
                    map(predictions =>
                        PredictionActions.loadUserPredictionsSuccess({ predictions: predictions })
                    ),
                    catchError(error =>
                        of(PredictionActions.loadUserPredictionsFailure({ error }))
                    )
                )
            )
        )
    );

    loadUserPredictionsSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(PredictionActions.loadUserPredictionsSuccess),
                tap(({ predictions }) => {
                })
            ),
        { dispatch: false }
    );

    loadUserPredictionsFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(PredictionActions.loadUserPredictionsFailure),
                tap(({ error }) => {
                })
            ),
        { dispatch: false }
    );
    loadUserHistoryPredictions$ = createEffect(() =>
        this.actions$.pipe(
            ofType(PredictionActions.loadUserHistoryPredictions),
            switchMap(({ userId }) =>
                this.predictionService.getUserHistoryPredictions(userId).pipe(
                    map(predictions =>
                        PredictionActions.loadUserHistoryPredictionsSuccess({ predictions: predictions })
                    ),
                    catchError(error =>
                        of(PredictionActions.loadUserHistoryPredictionsFailure({ error }))
                    )
                )
            )
        )
    );
    loadUserHistoryPredictionsSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(PredictionActions.loadUserHistoryPredictionsSuccess),
                tap(({ predictions }) => {
                })
            ),
        { dispatch: false }
    );
    loadUserHistoryPredictionsFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(PredictionActions.loadUserHistoryPredictionsFailure),
                tap(({ error }) => {
                })
            ),
        { dispatch: false }
    );

    loadPredictionDetails$ = createEffect(() =>
        this.actions$.pipe(
            ofType(PredictionActions.loadPredictionDetails),
            switchMap(({ predictionId, userId }) =>
                this.predictionService.getPredictionDetails(predictionId, userId).pipe(
                    map(prediction =>
                        PredictionActions.loadPredictionDetailsSuccess({ prediction: prediction })
                    ),
                    catchError(error =>
                        of(PredictionActions.loadPredictionDetailsFailure({ error }))
                    )
                )
            )
        )
    );

    createPrediction$ = createEffect(() =>
        this.actions$.pipe(
            ofType(PredictionActions.createPrediction),
            switchMap(action =>
                this.predictionService.createPrediction(action).pipe(
                    map(() => PredictionActions.createPredictionSuccess()),
                    catchError(error =>
                        of(PredictionActions.createPredictionFailure({ error }))
                    )
                )
            )
        )
    );

    createPredictionSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(PredictionActions.createPredictionSuccess),
                tap(() => {
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Prédiction créée avec succès',
                        life: 3000
                    });

                })
            ),
        { dispatch: false }
    );

    deletePrediction$ = createEffect(() =>
        this.actions$.pipe(
            ofType(PredictionActions.deletePrediction),
            switchMap(({ predictionId }) =>
                this.predictionService.deletePrediction(predictionId).pipe(
                    map(() => PredictionActions.deletePredictionSuccess()),
                    catchError(error =>
                        of(PredictionActions.deletePredictionFailure({ error }))
                    )
                )
            )
        )
    );
    deletePredictionSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(PredictionActions.deletePredictionSuccess),
                tap(() => {
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Prédiction supprimée avec succès',
                        life: 3000
                    });
                })
            ),
        { dispatch: false }
    );
    deletePredictionFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(PredictionActions.deletePredictionFailure),
                tap(({ error }) => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Échec de la suppression de la prédiction',
                        life: 3000
                    });
                })
            ),
        { dispatch: false }
    );



}